import React from 'react';

class FieldTextarea extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            value: '',
        };

        this._onChange = this._onChange.bind(this);
    }

    _onChange(event) {
        this.setState({value: event.target.value});
    }

    render() {
        const {item} = this.props;
        const req = (item.req === "Y") ? "_req" : "";
        const required_sign = (item.req === "Y") ? <sup>*</sup> : '';
        const filled = (this.state.value) ? 'is-not-empty' :'';

        return (
            <div className="order-props__prop-item">
                <div className="form-control">
                    <textarea defaultValue=""
                              maxLength={490}
                              name={item.property_id}
                              id={item.property_id}
                              onChange={this._onChange}
                              className={req + filled}/>
                    <label htmlFor={item.property_id}>{item.name} {required_sign}</label>
                </div>
            </div>
        );
    }
}

export default FieldTextarea